import { useMutation } from '@apollo/client';
import { graphql } from '@client/graphql/types';

const QUERY = graphql(`
  mutation createNewsBanner($companyId: ID!, $input: CreateNewsBannerInput!) {
    createNewsBanner(companyId: $companyId, input: $input) {
      ...NewsBannerItem
    }
  }
`);

export function useCreateNewsBanner() {
  return useMutation(QUERY, {
    refetchQueries: ['newsBanners', 'newsBanner'],
  });
}
